import axiosInstance from "../axiosInstance";

const get = async (path, params, signal) => {
  const response = await axiosInstance.get(path, { params, signal, suppressErrorToast: true });
  return response.data;
};

export const purchaseOrderAnalysisService = {
  // Overview for one warehouse: KPIs, coverage matrix, inbound calendar, reliability.
  fetchOverview: (params, { signal } = {}) => get("/purchase-order-analysis", params, signal),
  // One PO in full (lines, deliveries, trail), loaded when a PO row is opened.
  fetchPo: (poId, params, { signal } = {}) =>
    get(`/purchase-order-analysis/${encodeURIComponent(poId)}`, params, signal),
  // One page of the coverage (table=coverage) or PO (table=pos) table.
  fetchRows: (params, { signal } = {}) => get("/purchase-order-analysis-rows", params, signal),
  // SKU lookup: suggestions (search) or one SKU's PO history + stock runway (sku).
  fetchSku: (params, { signal } = {}) => get("/purchase-order-analysis-sku", params, signal),
};
